module.exports = __webpack_public_path__ + "img/medic.0b389311.jpg";